<section class="orders-board">
  @for (type of ORDER_TYPES; track type) {
    <section class="order-type-column">
      <header>
        <span>{{ ORDER_TYPE_CONFIG[type].label | uppercase }}</span>
        <span>{{ groupedOrders[type].length }}</span>
      </header>

      @let previousListId = 'order-list-' + ($index > 0 ? ORDER_TYPES[$index - 1] : ORDER_TYPES[$index]);
      @let nextListId = 'order-list-' + ($index < ORDER_TYPES.length - 1 ? ORDER_TYPES[$index + 1] : ORDER_TYPES[$index]);

      <ul class="order-list" [class.drop-target]="draggingFromType && isAllowedTarget(type)"
          cdkDropList [id]="'order-list-' + ORDER_TYPES[$index]"
          [cdkDropListData]="groupedOrders[type]"
          [cdkDropListConnectedTo]="[previousListId, nextListId]"
          [cdkDropListEnterPredicate]="canEnterDropList"
          (cdkDropListDropped)="drop($event, type)"
          cdkDropListOrientation="vertical">

        @for (order of groupedOrders[type]; track order.id) {
          <li cdkDrag [cdkDragData]="order"
              (cdkDragStarted)="draggingFromType = type"
              (cdkDragEnded)="draggingFromType = undefined">
            <oaibox-operation-item [order]="order"></oaibox-operation-item>
          </li>
        }
      </ul>
    </section>
  }
</section>
